import React, { useEffect } from 'react';

import * as Styles from './_marketStatusStyles.module.scss';
import ActionButton from '~components/atoms/ActionButton';
import { useAppDispatch, useAppSelector } from '~redux/hooks';
import combinedActions from '~redux/combinedActions';
import LabelledInput from '~components/atoms/LabelledInput';
import { MarketStatusEnum, ModuleEnum, PermissionsEnum } from '~utils/enums';
import dayjs from 'dayjs';
import TabPageContainer from '~components/atoms/TabPageContainer';
import TabPageHeaderWrapper from '~components/atoms/TabPageHeaderWrapper';
import ConfirmUpdateMarketStatusModal from './ConfirmUpdateMarketStatusModal';
import ConfirmUpdateMarketStatusCloseModal from './ConfirmUpdateMarketStatusCloseModal';

const MarketStatus = () => {
    const dispatch = useAppDispatch();

    const marketHourStatus = useAppSelector(state => state.dashboard.dashboardMarketStatus);

    const userAccess = useAppSelector(state => state.auth.userDetails.access);

    const editAccessModules = userAccess.find(access => access.permission === PermissionsEnum.Edit)?.modules || [];

    useEffect(() => {
        dispatch(combinedActions.dashboardGetDashboardMarketStatusAttempt());
    }, []);

    const handleOpenMarketClicked = () => {
        dispatch(combinedActions.dashboardIsMarketStatusOpenConfimationModalOpen(true));
    };

    const handleCloseMarketClicked = () => {
        dispatch(combinedActions.dashboardIsMarketStatusCloseConfimationModalOpen(true));
    };

    return (
        <TabPageContainer>
            <TabPageHeaderWrapper>

            </TabPageHeaderWrapper>

            <div className={Styles.container}>

                {
                    editAccessModules.find(module => module === ModuleEnum.MarketStatus) && (
                        <div className={Styles['action-container']}>
                            <ActionButton
                                className={Styles['edit-button']}
                                label='Open Market'
                                onClick={handleOpenMarketClicked}
                                disabled={marketHourStatus.status === MarketStatusEnum.Open}
                            />

                            <ActionButton
                                className={Styles['edit-button']}
                                label='Close Market'
                                onClick={handleCloseMarketClicked}
                                disabled={marketHourStatus.status === MarketStatusEnum.Close}
                            />
                        </div>
                    )
                }

                <form
                    className={Styles['form-container']}
                >
                    <div className={Styles['form-subcontainer']}>
                        <div>Market Status</div>
                        <LabelledInput
                            id='endDate'
                            name='endDate'
                            label=':'
                            value={MarketStatusEnum[marketHourStatus.status]}
                            disabled={true}
                            isRow
                        />

                        <div>Market Time</div>

                        <LabelledInput
                            id='apiKey'
                            name='apiKey'
                            label=':'
                            value={dayjs(marketHourStatus.currentTime).format('DD/MM/YYYY hh:mm A')}
                            disabled={true}
                            isRow
                        />
                    </div>
                </form>
            </div>

            <ConfirmUpdateMarketStatusModal />
            <ConfirmUpdateMarketStatusCloseModal />
        </TabPageContainer>

    );
};

export default MarketStatus;
